<template>
  <div>
    <div ref="echartsContainer" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props:['bindUserData','bindUservalData'],
  mounted() {
    var myChart = echarts.init(this.$refs.echartsContainer);
    myChart.setOption({
      // ECharts 配置项
      title: {
        text: "",
      },
      tooltip: {},
      xAxis: {
        data: this.bindUserData,
         axisLabel: {
          interval: 0,
          rotate: 40,
        },
      },
      yAxis: {
         splitLine: { show: false },
      },
         dataZoom: [
          {
            //  // 设置滚动条的隐藏与显示
            show: true,
            // 设置滚动条类型
            type: "inside",
            // 设置背景颜色
            // backgroundColor: "rgb(19, 63, 100)",
            // 设置选中范围的填充颜色
            // fillerColor: "rgb(16, 171, 198)",
            // 设置边框颜色
            // borderColor: "rgb(19, 63, 100)",
            // 是否显示detail，即拖拽时候显示详细数值信息
            showDetail: false,
            // 数据窗口范围的起始数值
            startValue: 0,
            // 数据窗口范围的结束数值（一页显示多少条数据）
            endValue: 6,
            // empty：当前数据窗口外的数据，被设置为空。
            // 即不会影响其他轴的数据范围
            filterMode: "empty",
            // 设置滚动条宽度，相对于盒子宽度
            width: "100%",
            // 设置滚动条高度
            height: 10,
            // 设置滚动条显示位置
            // left: "center",
            // 是否锁定选择区域（或叫做数据窗口）的大小
            zoomLoxk: true,
            // 控制手柄的尺寸
            handleSize: 0,
            // dataZoom-slider组件离容器下侧的距离
            bottom: 8,
          },
          {
            // 没有下面这块的话，只能拖动滚动条，
            // 鼠标滚轮在区域内不能控制外部滚动条
            type: "inside",
            // 滚轮是否触发缩放
            zoomOnMouseWheel: false,
            // 鼠标滚轮触发滚动
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
          },
        ],
      series: [
        {
          name: "",
          type: "bar",
          barWidth: 10,
          itemStyle: {
            normal: {
              barBorderRadius: 5,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#956FD4" },
                { offset: 1, color: "#3EACE5" },
              ]),
            },
          },
          data: this.bindUservalData,
        },
      ],
    });
  },
}
</script>

<style>

</style>